export function validateEmptyString(value) {
	return value.trim() !== '';
}

export function validateNotNull(value) {
	return (value != null);
}

export function validateInitial(value) {
	if(value == null || value.trim() === "") return true;
	const regex = /^([A-Z]\.\s?)*$/;
	return value.search(regex) !== -1;
}

export function validateStreetNumber(value) {
	const regex = /^[+\s\d]+-?[a-zA-Z]*\d*$/;
	return value.search(regex) !== -1;
}

export function validatePhoneNumber(value) {
	const regex = /^[+\s0-9]+$/;
	return value.search(regex) !== -1;
}

export function validateEmail(value) {
	const regex = /^(.+)@(.+)\.(.+)$/;
	return value.search(regex) !== -1;
}

export function validateNotRequiredEmail(value) {
	if(value == null || value.trim() === "") return true;
	const regex = /^(.+)@(.+)\.(.+)$/;
	return value.search(regex) !== -1;
}

export function validatePostalCode(value) {
	const regex = /^[0-9]{4}[a-zA-Z]{2}$/;
	return value.search(regex) !== -1;
}

export function validateBuildYear(value) {
	return value > 1800 && value < (new Date()).getFullYear() + 1;
}

export function validateHexColor(value) {
	if(value == null || value.trim() === "") return true;
	const regex = /^#[\da-f]{6}$/;
	return value.search(regex) !== -1;
}

export function validateTime(value) {
	const regex = /^([0-1]\d|2[0-3]):[0-5]\d$/;
	return value.search(regex) !== -1;
}

export function validateNotEmptyOrEmptyString(value) {
	if (value == null || typeof value !== "string" || value.trim() === '') {
		return false;
	}

	return true;
}
